import { Handle } from "reactflow";

const NodeHandle = ({ handleId, position, target }) => {
  return (
    <div className="relative -ml-3">
      <Handle type={target} position={position} id={handleId} />
    </div>
  );
};

export default NodeHandle;
